<template>
  <div className="UserRule">
    <p v-html="data"></p>
  </div>
</template>

<script>
export default {
  name: "UserRule",
  data () {
    return {
      data:
        '<html xmlns:v="urn:schemas-microsoft-com:vml"\n' +
        'xmlns:o="urn:schemas-microsoft-com:office:office"\n' +
        'xmlns:w="urn:schemas-microsoft-com:office:word"\n' +
        'xmlns:m="http://schemas.microsoft.com/office/2004/12/omml"\n' +
        'xmlns="http://www.w3.org/TR/REC-html40">\n' +
        "\n" +
        "<head>\n" +
        '<meta http-equiv=Content-Type content="text/html; charset=gb2312">\n' +
        "<meta name=ProgId content=Word.Document>\n" +
        '<meta name=Generator content="Microsoft Word 12">\n' +
        '<meta name=Originator content="Microsoft Word 12">\n' +
        '<link rel=File-List href="使用协议(1).files/filelist.xml">\n' +
        "<!--[if gte mso 9]><xml>\n" +
        " <o:DocumentProperties>\n" +
        "  <o:Author>Lyz</o:Author>\n" +
        "  <o:LastAuthor>W10</o:LastAuthor>\n" +
        "  <o:Revision>2</o:Revision>\n" +
        "  <o:TotalTime>40</o:TotalTime>\n" +
        "  <o:Created>2021-06-23T02:00:00Z</o:Created>\n" +
        "  <o:LastSaved>2021-06-23T02:00:00Z</o:LastSaved>\n" +
        "  <o:Pages>9</o:Pages>\n" +
        "  <o:Words>800</o:Words>\n" +
        "  <o:Characters>4566</o:Characters>\n" +
        "  <o:Lines>38</o:Lines>\n" +
        "  <o:Paragraphs>10</o:Paragraphs>\n" +
        "  <o:CharactersWithSpaces>5356</o:CharactersWithSpaces>\n" +
        "  <o:Version>12.00</o:Version>\n" +
        " </o:DocumentProperties>\n" +
        " <o:OfficeDocumentSettings>\n" +
        "  <o:AllowPNG/>\n" +
        " </o:OfficeDocumentSettings>\n" +
        "</xml><![endif]-->\n" +
        '<link rel=themeData href="使用协议(1).files/themedata.thmx">\n' +
        '<link rel=colorSchemeMapping href="使用协议(1).files/colorschememapping.xml">\n' +
        "<!--[if gte mso 9]><xml>\n" +
        " <w:WordDocument>\n" +
        "  <w:TrackMoves>false</w:TrackMoves>\n" +
        "  <w:TrackFormatting/>\n" +
        "  <w:PunctuationKerning/>\n" +
        "  <w:DrawingGridVerticalSpacing>7.8 磅</w:DrawingGridVerticalSpacing>\n" +
        "  <w:DisplayHorizontalDrawingGridEvery>0</w:DisplayHorizontalDrawingGridEvery>\n" +
        "  <w:DisplayVerticalDrawingGridEvery>2</w:DisplayVerticalDrawingGridEvery>\n" +
        "  <w:ValidateAgainstSchemas/>\n" +
        "  <w:SaveIfXMLInvalid>false</w:SaveIfXMLInvalid>\n" +
        "  <w:IgnoreMixedContent>false</w:IgnoreMixedContent>\n" +
        "  <w:AlwaysShowPlaceholderText>false</w:AlwaysShowPlaceholderText>\n" +
        "  <w:DoNotPromoteQF/>\n" +
        "  <w:LidThemeOther>EN-US</w:LidThemeOther>\n" +
        "  <w:LidThemeAsian>ZH-CN</w:LidThemeAsian>\n" +
        "  <w:LidThemeComplexScript>X-NONE</w:LidThemeComplexScript>\n" +
        "  <w:Compatibility>\n" +
        "   <w:SpaceForUL/>\n" +
        "   <w:BalanceSingleByteDoubleByteWidth/>\n" +
        "   <w:DoNotLeaveBackslashAlone/>\n" +
        "   <w:ULTrailSpace/>\n" +
        "   <w:DoNotExpandShiftReturn/>\n" +
        "   <w:AdjustLineHeightInTable/>\n" +
        "   <w:BreakWrappedTables/>\n" +
        "   <w:SnapToGridInCell/>\n" +
        "   <w:WrapTextWithPunct/>\n" +
        "   <w:UseAsianBreakRules/>\n" +
        "   <w:DontGrowAutofit/>\n" +
        "   <w:SplitPgBreakAndParaMark/>\n" +
        "   <w:DontVertAlignCellWithSp/>\n" +
        "   <w:DontBreakConstrainedForcedTables/>\n" +
        "   <w:DontVertAlignInTxbx/>\n" +
        "   <w:Word11KerningPairs/>\n" +
        "   <w:CachedColBalance/>\n" +
        "   <w:UseFELayout/>\n" +
        "  </w:Compatibility>\n" +
        "  <m:mathPr>\n" +
        '   <m:mathFont m:val="Cambria Math"/>\n' +
        '   <m:brkBin m:val="before"/>\n' +
        '   <m:brkBinSub m:val="--"/>\n' +
        "   <m:smallFrac/>\n" +
        "   <m:dispDef/>\n" +
        '   <m:lMargin m:val="0"/>\n' +
        '   <m:rMargin m:val="0"/>\n' +
        '   <m:defJc m:val="centerGroup"/>\n' +
        '   <m:wrapIndent m:val="1440"/>\n' +
        '   <m:intLim m:val="subSup"/>\n' +
        '   <m:naryLim m:val="undOvr"/>\n' +
        "  </m:mathPr></w:WordDocument>\n" +
        "</xml><![endif]--><!--[if gte mso 9]><xml>\n" +
        ' <w:LatentStyles DefLockedState="false" DefUnhideWhenUsed="true"\n' +
        '  DefSemiHidden="true" DefQFormat="false" DefPriority="99"\n' +
        '  LatentStyleCount="267">\n' +
        '  <w:LsdException Locked="false" Priority="0" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Normal"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="heading 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 7"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 8"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 9"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 7"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 8"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 9"/>\n' +
        '  <w:LsdException Locked="false" Priority="35" QFormat="true" Name="caption"/>\n' +
        '  <w:LsdException Locked="false" Priority="10" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Title"/>\n' +
        '  <w:LsdException Locked="false" Priority="1" Name="Default Paragraph Font"/>\n' +
        '  <w:LsdException Locked="false" Priority="11" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Subtitle"/>\n' +
        '  <w:LsdException Locked="false" Priority="22" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Strong"/>\n' +
        '  <w:LsdException Locked="false" Priority="20" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Emphasis"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Table Grid"/>\n' +
        '  <w:LsdException Locked="false" UnhideWhenUsed="false" Name="Placeholder Text"/>\n' +
        '  <w:LsdException Locked="false" Priority="1" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="No Spacing"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" UnhideWhenUsed="false" Name="Revision"/>\n' +
        '  <w:LsdException Locked="false" Priority="34" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="List Paragraph"/>\n' +
        '  <w:LsdException Locked="false" Priority="29" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Quote"/>\n' +
        '  <w:LsdException Locked="false" Priority="30" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Intense Quote"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="19" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Subtle Emphasis"/>\n' +
        '  <w:LsdException Locked="false" Priority="21" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Intense Emphasis"/>\n' +
        '  <w:LsdException Locked="false" Priority="31" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Subtle Reference"/>\n' +
        '  <w:LsdException Locked="false" Priority="32" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Intense Reference"/>\n' +
        '  <w:LsdException Locked="false" Priority="33" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Book Title"/>\n' +
        '  <w:LsdException Locked="false" Priority="37" Name="Bibliography"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" QFormat="true" Name="TOC Heading"/>\n' +
        " </w:LatentStyles>\n" +
        "</xml><![endif]-->\n" +
        "<style>\n" +
        "<!--\n" +
        " /* Font Definitions */\n" +
        " @font-face\n" +
        "\t{font-family:宋体;\n" +
        "\tpanose-1:2 1 6 0 3 1 1 1 1 1;\n" +
        "\tmso-font-alt:SimSun;\n" +
        "\tmso-font-charset:134;\n" +
        "\tmso-generic-font-family:auto;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:3 680460288 22 0 262145 0;}\n" +
        "@font-face\n" +
        '\t{font-family:"Cambria Math";\n' +
        "\tpanose-1:2 4 5 3 5 4 6 3 2 4;\n" +
        "\tmso-font-charset:0;\n" +
        "\tmso-generic-font-family:roman;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:-536869121 1107305727 33554432 0 415 0;}\n" +
        "@font-face\n" +
        "\t{font-family:Calibri;\n" +
        "\tpanose-1:2 15 5 2 2 2 4 3 2 4;\n" +
        "\tmso-font-charset:0;\n" +
        "\tmso-generic-font-family:swiss;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:-469750017 -1073732485 9 0 511 0;}\n" +
        "@font-face\n" +
        "\t{font-family:微软雅黑;\n" +
        "\tpanose-1:2 11 5 3 2 2 4 2 2 4;\n" +
        "\tmso-font-charset:134;\n" +
        "\tmso-generic-font-family:swiss;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:-2147483001 718224464 22 0 262175 0;}\n" +
        "@font-face\n" +
        '\t{font-family:"\\@微软雅黑";\n' +
        "\tpanose-1:2 11 5 3 2 2 4 2 2 4;\n" +
        "\tmso-font-charset:134;\n" +
        "\tmso-generic-font-family:swiss;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:-2147483001 718224464 22 0 262175 0;}\n" +
        "@font-face\n" +
        '\t{font-family:"\\@宋体";\n' +
        "\tpanose-1:2 1 6 0 3 1 1 1 1 1;\n" +
        "\tmso-font-charset:134;\n" +
        "\tmso-generic-font-family:auto;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:3 680460288 22 0 262145 0;}\n" +
        " /* Style Definitions */\n" +
        " p.MsoNormal, li.MsoNormal, div.MsoNormal\n" +
        "\t{mso-style-unhide:no;\n" +
        "\tmso-style-qformat:yes;\n" +
        '\tmso-style-parent:"";\n' +
        "\tmargin:0cm;\n" +
        "\tmargin-bottom:.0001pt;\n" +
        "\ttext-align:justify;\n" +
        "\ttext-justify:inter-ideograph;\n" +
        "\tmso-pagination:none;\n" +
        "\tfont-size:10.5pt;\n" +
        "\tmso-bidi-font-size:11.0pt;\n" +
        '\tfont-family:"Calibri","sans-serif";\n' +
        "\tmso-ascii-font-family:Calibri;\n" +
        "\tmso-ascii-theme-font:minor-latin;\n" +
        "\tmso-fareast-font-family:宋体;\n" +
        "\tmso-fareast-theme-font:minor-fareast;\n" +
        "\tmso-hansi-font-family:Calibri;\n" +
        "\tmso-hansi-theme-font:minor-latin;\n" +
        '\tmso-bidi-font-family:"Times New Roman";\n' +
        "\tmso-bidi-theme-font:minor-bidi;\n" +
        "\tmso-font-kerning:1.0pt;}\n" +
        "p.MsoHeader, li.MsoHeader, div.MsoHeader\n" +
        "\t{mso-style-priority:99;\n" +
        '\tmso-style-link:"页眉 Char";\n' +
        "\tmargin:0cm;\n" +
        "\tmargin-bottom:.0001pt;\n" +
        "\ttext-align:center;\n" +
        "\tmso-pagination:none;\n" +
        "\ttab-stops:center 207.65pt right 415.3pt;\n" +
        "\tlayout-grid-mode:char;\n" +
        "\tborder:none;\n" +
        "\tmso-border-bottom-alt:solid windowtext .75pt;\n" +
        "\tpadding:0cm;\n" +
        "\tmso-padding-alt:0cm 0cm 1.0pt 0cm;\n" +
        "\tfont-size:9.0pt;\n" +
        '\tfont-family:"Calibri","sans-serif";\n' +
        "\tmso-ascii-font-family:Calibri;\n" +
        "\tmso-ascii-theme-font:minor-latin;\n" +
        "\tmso-fareast-font-family:宋体;\n" +
        "\tmso-fareast-theme-font:minor-fareast;\n" +
        "\tmso-hansi-font-family:Calibri;\n" +
        "\tmso-hansi-theme-font:minor-latin;\n" +
        '\tmso-bidi-font-family:"Times New Roman";\n' +
        "\tmso-bidi-theme-font:minor-bidi;\n" +
        "\tmso-font-kerning:1.0pt;}\n" +
        "p.MsoFooter, li.MsoFooter, div.MsoFooter\n" +
        "\t{mso-style-priority:99;\n" +
        '\tmso-style-link:"页脚 Char";\n' +
        "\tmargin:0cm;\n" +
        "\tmargin-bottom:.0001pt;\n" +
        "\tmso-pagination:none;\n" +
        "\ttab-stops:center 207.65pt right 415.3pt;\n" +
        "\tlayout-grid-mode:char;\n" +
        "\tfont-size:9.0pt;\n" +
        '\tfont-family:"Calibri","sans-serif";\n' +
        "\tmso-ascii-font-family:Calibri;\n" +
        "\tmso-ascii-theme-font:minor-latin;\n" +
        "\tmso-fareast-font-family:宋体;\n" +
        "\tmso-fareast-theme-font:minor-fareast;\n" +
        "\tmso-hansi-font-family:Calibri;\n" +
        "\tmso-hansi-theme-font:minor-latin;\n" +
        '\tmso-bidi-font-family:"Times New Roman";\n' +
        "\tmso-bidi-theme-font:minor-bidi;\n" +
        "\tmso-font-kerning:1.0pt;}\n" +
        "p\n" +
        "\t{mso-style-noshow:yes;\n" +
        "\tmso-style-priority:99;\n" +
        "\tmso-margin-top-alt:auto;\n" +
        "\tmargin-right:0cm;\n" +
        "\tmso-margin-bottom-alt:auto;\n" +
        "\tmargin-left:0cm;\n" +
        "\tmso-pagination:widow-orphan;\n" +
        "\tfont-size:12.0pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tmso-bidi-font-family:宋体;}\n" +
        "span.pt\n" +
        "\t{mso-style-name:pt;\n" +
        "\tmso-style-unhide:no;}\n" +
        "span.Char\n" +
        '\t{mso-style-name:"页眉 Char";\n' +
        "\tmso-style-priority:99;\n" +
        "\tmso-style-unhide:no;\n" +
        "\tmso-style-locked:yes;\n" +
        "\tmso-style-link:页眉;\n" +
        "\tmso-ansi-font-size:9.0pt;\n" +
        "\tmso-bidi-font-size:9.0pt;}\n" +
        "span.Char0\n" +
        '\t{mso-style-name:"页脚 Char";\n' +
        "\tmso-style-priority:99;\n" +
        "\tmso-style-unhide:no;\n" +
        "\tmso-style-locked:yes;\n" +
        "\tmso-style-link:页脚;\n" +
        "\tmso-ansi-font-size:9.0pt;\n" +
        "\tmso-bidi-font-size:9.0pt;}\n" +
        ".MsoChpDefault\n" +
        "\t{mso-style-type:export-only;\n" +
        "\tmso-default-props:yes;\n" +
        '\tmso-bidi-font-family:"Times New Roman";\n' +
        "\tmso-bidi-theme-font:minor-bidi;}\n" +
        " /* Page Definitions */\n" +
        " @page\n" +
        "\t{mso-page-border-surround-header:no;\n" +
        "\tmso-page-border-surround-footer:no;\n" +
        '\tmso-footnote-separator:url("使用协议\\(1\\).files/header.htm") fs;\n' +
        '\tmso-footnote-continuation-separator:url("使用协议\\(1\\).files/header.htm") fcs;\n' +
        '\tmso-endnote-separator:url("使用协议\\(1\\).files/header.htm") es;\n' +
        '\tmso-endnote-continuation-separator:url("使用协议\\(1\\).files/header.htm") ecs;}\n' +
        "@page Section1\n" +
        "\t{size:595.3pt 841.9pt;\n" +
        "\tmargin:72.0pt 90.0pt 72.0pt 90.0pt;\n" +
        "\tmso-header-margin:42.55pt;\n" +
        "\tmso-footer-margin:49.6pt;\n" +
        "\tmso-paper-source:0;\n" +
        "\tlayout-grid:15.6pt;}\n" +
        "div.Section1\n" +
        "\t{page:Section1;}\n" +
        "-->\n" +
        "</style>\n" +
        "<!--[if gte mso 10]>\n" +
        "<style>\n" +
        " /* Style Definitions */\n" +
        " table.MsoNormalTable\n" +
        "\t{mso-style-name:普通表格;\n" +
        "\tmso-tstyle-rowband-size:0;\n" +
        "\tmso-tstyle-colband-size:0;\n" +
        "\tmso-style-noshow:yes;\n" +
        "\tmso-style-priority:99;\n" +
        "\tmso-style-qformat:yes;\n" +
        '\tmso-style-parent:"";\n' +
        "\tmso-padding-alt:0cm 5.4pt 0cm 5.4pt;\n" +
        "\tmso-para-margin:0cm;\n" +
        "\tmso-para-margin-bottom:.0001pt;\n" +
        "\tmso-pagination:widow-orphan;\n" +
        "\tfont-size:10.5pt;\n" +
        "\tmso-bidi-font-size:11.0pt;\n" +
        '\tfont-family:"Calibri","sans-serif";\n' +
        "\tmso-ascii-font-family:Calibri;\n" +
        "\tmso-ascii-theme-font:minor-latin;\n" +
        "\tmso-hansi-font-family:Calibri;\n" +
        "\tmso-hansi-theme-font:minor-latin;\n" +
        '\tmso-bidi-font-family:"Times New Roman";\n' +
        "\tmso-bidi-theme-font:minor-bidi;\n" +
        "\tmso-font-kerning:1.0pt;}\n" +
        "</style>\n" +
        "<![endif]--><!--[if gte mso 9]><xml>\n" +
        ' <o:shapedefaults v:ext="edit" spidmax="5122"/>\n' +
        "</xml><![endif]--><!--[if gte mso 9]><xml>\n" +
        ' <o:shapelayout v:ext="edit">\n' +
        '  <o:idmap v:ext="edit" data="1"/>\n' +
        " </o:shapelayout></xml><![endif]-->\n" +
        "</head>\n" +
        "\n" +
        "<body lang=ZH-CN style='tab-interval:21.0pt;text-justify-trim:punctuation'>\n" +
        "\n" +
        "<div class=Section1 style='layout-grid:15.6pt'>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>欢迎阅读《<span\n' +
        "lang=EN-US>APP</span>用户服务协议》<span lang=EN-US>(</span>以下简称“本协议”<span lang=EN-US>)</span>。本协议阐述之条款和条件适用于您（以下简称“用户”）使用<span\n" +
        "lang=EN-US>APP</span>的各种产品和服务。<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        "background:white'><span class=pt><b><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif"\'>1. </span></b></span><span class=pt><b><span\n' +
        'style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif"\'>服务协议的确认</span></b></span><span\n' +
        'lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'><o:p></o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>1.1</span><span\n' +
        'style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>云圈科技有限公司及相关关联企业（以下合称“云圈公司”）同意按照本协议的规定及其不时发布的操作规则提供基于互联网移动网的<a\n' +
        'name="_GoBack"></a><span lang=EN-US>APP</span>相关服务（以下简称“云圈服务”）。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>1.2\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>云圈服务使用人（以下简称“用户”）应当基于了解本协议全部内容、在独立思考的基础上认可、同意本协议的全部条款并按照页面上的提示完成全部的注册程序，用户的注册、登录、使用等行为将视为完全接受本协议及云圈公司公示的各项规则、规范。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>1.3\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>云圈公司享有对云圈<span\n' +
        "lang=EN-US>APP</span>上一切活动的监督、提示、检查、纠正等权利。<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        "background:white'><span class=pt><b><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif"\'>2. </span></b></span><span class=pt><b><span\n' +
        'style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif"\'>服务内容</span></b></span><span\n' +
        'lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'><o:p></o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>2.1\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>云圈服务的具体内容由云圈公司根据实际情况提供，包括但不限于授权用户通过其帐号上传、搜索并向互相关联的用户推送相关信息、授权用户对其进行收录、分享等，云圈公司有权对其提供的服务或产品形态进行升级或其他调整，均以<span\n' +
        "lang=EN-US>APP\\</span>网站内容更新的方式通知用户，不单独通知用户。<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>2.2\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>云圈公司提供的云圈服务中可能包括广告，用户同意在使用过程中显示云圈和第三方供应商、合作伙伴提供的广告。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>2.3\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>云圈公司仅提供与云圈服务相关的技术服务等，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负担。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        "background:white'><span class=pt><b><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif"\'>3. </span></b></span><span class=pt><b><span\n' +
        'style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif"\'>服务变更、中断或终止</span></b></span><span\n' +
        'lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'><o:p></o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>3.1\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>鉴于网络服务的特殊性（包括但不限于不可抗力、网络稳定性、系统稳定性、技术故障、用户所在位置、用户关机、用户手机病毒或恶意的网络攻击行为及其他任何技术、互联网络、通信线路、内容侵权等原因），用户同意，云圈公司有权随时中断或终止部分或全部云圈服务，云圈公司将尽可能及时以合理方式通知用户，并尽可能在第一时间对此进行修复。但对因此导致用户不能发送和接受阅读信息、或接发错信息，云圈公司不承担任何责任，用户须承担以上风险。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>3.2\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>用户理解，云圈公司需要定期或不定期地对提供云圈服务的平台或相关设备进行检修和维护，如因此类情况而造成服务在合理期间内的中断，云圈公司将尽可能事先通知，但无需为此承担任何责任。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>3.3\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>用户提供的个人资料不真实、用户违反法律法规国家政策或本协议规定的使用规则，云圈公司有权随时中断或终止向用户提供本协议项下的云圈服务，而无需对用户或任何第三方承担任何责任。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        "background:white'><span class=pt><b><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif"\'>4. </span></b></span><span class=pt><b><span\n' +
        'style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif"\'>使用规则</span></b></span><span\n' +
        'lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'><o:p></o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>4.1\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>用户在申请注册云圈服务时，必须向云圈公司提供准确的主体资料（用户为个人时，包括姓名、电话等；用户为单位时，包括名称、注册地址、注册号等），如主体资料有任何变动，必须及时更新。因用户提供资料的真实性问题导致协议双方或第三方的任何损失均由用户承担。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>4.2\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>用户注册成功后，将获得一个云圈帐号及由用户设置的密码，该用户帐号和密码由用户负责保管；用户应当对该用户帐号所有行为负相关法律责任。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>用户在使用云圈服务过程中，必须遵循以下原则<span\n' +
        "lang=EN-US>:<o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(1)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>遵守中国有关的法律和法规；<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(2)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>不得为任何非法目的而使用云圈服务；<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(3)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>遵守所有与网络服务有关的网络协议、规定和程序；<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(4)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>不得利用云圈服务系统进行任何可能对互联网的正常运转造成不利影响的行为；<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(5)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>不得利用云圈网络服务系统进行任何不利于云圈公司的行为。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>4.3\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>用户不得使用云圈服务制作、上传、发送、传播敏感信息和违反国家法律制度的信息，包括但不限于下列信息<span\n' +
        "lang=EN-US>:<o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(1)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>反对宪法所确定的基本原则的；<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(2)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(3)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>损害国家荣誉和利益的；<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(4)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>煽动民族仇恨、民族歧视，破坏民族团结的；<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(5)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>破坏国家宗教政策，宣扬邪教和封建迷信的；<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(6)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>散布谣言，扰乱社会秩序，破坏社会稳定的；<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(7)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(8)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>侮辱或者诽谤他人，侵害他人合法权益的；<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(9)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>含有法律、行政法规禁止的其他内容的。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>4.4\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>用户同意在任何情况下不使用其他用户的帐号或密码。在您怀疑他人在使用您的帐号或密码时，您同意立即通知云圈公司。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>4.5\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>用户有权更改、删除在云圈服务中的个人资料、注册信息及传送内容等，但删除有关信息的同时也会删除任何您储存在系统中的文字和图片。用户需承担该风险。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>4.6\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>如因用户违反本协议中的任何条款，云圈公司有权依据本协议终止对违约用户云圈帐号提供服务。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>4.7\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>如用户注册云圈帐号后长期不登录该帐号，云圈公司有权回收该帐号，以免造成资源浪费，由此带来问题均由用户自行承担。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        "background:white'><span class=pt><b><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif"\'>5. </span></b></span><span class=pt><b><span\n' +
        'style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif"\'>知识产权</span></b></span><span\n' +
        'lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'><o:p></o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>5.1\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>云圈公司提供云圈服务中所包含的任何文本、图片、标识、音频、视频资料均受著作权、商标权、专利权及其他财产权法律的保护。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>5.2\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>未经相关权利人和云圈公司的同意，上述资料均不得以任何方式被展示于其他任何第三方平台或被用于其他任何商业目的；用户不得擅自复制、修改、编纂上述内容、或创造与内容有关的衍生产品。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        "background:white'><span class=pt><b><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif"\'>6. </span></b></span><span class=pt><b><span\n' +
        'style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif"\'>隐私保护</span></b></span><span\n' +
        'lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'><o:p></o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>6.1\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>本协议所指的“隐私”包括《电信和互联网用户个人信息保护规定》第<span\n' +
        "lang=EN-US>4</span>条规定的用户个人信息的内容以及未来不时制定或修订的法律法规中明确规定的隐私应包括的内容。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>6.2\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>保护用户隐私和个人数据是云圈公司的一项基本制度，云圈公司将采取各种制度、安全技术和程序等措施来保护用户隐私和个人数据不被未经授权的访问、使用或泄漏，并保证不会将单个用户的注册资料及用户在使用云圈服务时存储在云圈公司的非公开内容向除合作单位以外的第三方公开或用于任何非法的用途，但下列情况除外：<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(1)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>事先获得用户的明确授权；<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(2)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>根据有关法律法规的要求；<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(3)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>按照相关政府主管部门的要求；<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(4)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>为维护社会公众的利益；<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>(5)\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>用户侵害本协议项下云圈公司的合法权益的情况下而为维护云圈公司的合法权益所必须。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>6.3\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>用户在注册云圈<span\n' +
        "lang=EN-US>APP</span>帐号或使用云圈<span lang=EN-US>APP</span>服务的过程中，需要提供一些必要的信息，例如：姓名、电话等。为向用户提供帐号注册服务或进行用户身份识别，需要用户填写手机号码；部分功能需要用户授权使用用户的相机或相册；部分功能需要用户授权访问用户的手机通讯录等。若用户不授权或提供的信息不完整，则无法使用本服务或在使用过程中受到限制。用户授权提供的信息，云圈公司承诺将采取措施保护用户的个人信息安全。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>6.4\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>为了向用户提供更好的用户体验和提高云圈<span\n' +
        "lang=EN-US>APP</span>的服务质量，云圈公司将可能会收集使用或向第三方提供用户的非个人隐私信息。云圈公司将对该第三方使用用户个人数据的行为进行监督和管理，尽一切可能努力保护用户个人信息的安全。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'><o:p>&nbsp;</o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-align:justify;text-justify:\n" +
        "inter-ideograph;text-indent:24.1pt;line-height:22.5pt;background:white'><b\n" +
        "style='mso-bidi-font-weight:normal'><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif"\'>7.</span></b><b style=\'mso-bidi-font-weight:\n' +
        'normal\'><span style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif"\'>用户行为<span\n' +
        "lang=EN-US><o:p></o:p></span></span></b></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.1pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>7.1</span><span\n' +
        'style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>　用户理解并保证在教育圈上传、发布或传输的内容（包括帐户名称等信息）应当遵守宪法、法律和行政法规，坚持正确舆论导向，符合积极健康、向上向善的网络文化，自觉维护国家利益和公共利益。我方有权对用户上传、发布或传输的信息进行管理，发现法律、行政法规禁止发布或者传输的信息的，或含有以下内容的，我方将立即传输该信息，采取消除等处置措施，防止信息扩散，保存有关记录，并向有关主管部门报告：<span\n' +
        "lang=EN-US><br>\n" +
        "</span>（<span lang=EN-US>1</span>）反对宪法确定的基本原则的；<span lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>2</span>）危害国家统一、主权和领土完整的；　　<span lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>3</span>）泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；　<span lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>4</span>）煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；　　<span\n" +
        "lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>5</span>）宣扬邪教、迷信的；　<span lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>6</span>）扰乱社会秩序，破坏社会稳定的；　<span lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>7</span>）诱导未成年人违法犯罪和渲染暴力、色情、赌博、恐怖活动的；　<span\n" +
        "lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>8</span>）侮辱或者诽谤他人，侵害公民个人名誉、隐私、知识产权和其他合法权益的；　<span\n" +
        "lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>9</span>）危害社会公德，损害民族优秀文化传统的；　　<span lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>10</span>）有关法律、行政法规和国家规定禁止的其他内容。<span lang=EN-US><br>\n" +
        "</span>如果用户上传、发布或传输内容含有以上违反政策法律法规的信息或内容的，或者侵犯任何第三方的合法权益，用户应直接承担以上导致的一切不利后果。如因此给我方造成不利后果的，用户应负责消除影响，并且赔偿我方因此导致的一切损失，包括且不限于财产损害赔偿、名誉损害赔偿、律师费、交通费等因维权而产生的合理费用或其他所有平台要求的合理费用。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.1pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>7.2</span><span\n' +
        'style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>　<span lang=EN-US>&nbsp;</span>用户理解并保证不在教育圈进行下列的禁止的行为，也不允许任何人利用用户的帐户进行下列行为：<span\n' +
        "lang=EN-US><br>\n" +
        "</span>（<span lang=EN-US>1)&nbsp;</span>发送任何未获邀约或未经授权的垃圾电邮、广告或宣传资料，或任何其他商业通讯；<span\n" +
        "lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>2)&nbsp;</span>未经我方明确许可，使用我方平台服务用于任何商业用途或为任何第三方的利益；<span\n" +
        "lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>3)&nbsp;</span>使用或利用我方知识产权（包括我们的商标、品牌、标志、任何其他专有数据或任何网页的布局或设计），或以其他形式侵犯我方任何知识产权；<span\n" +
        "lang=EN-US>&nbsp;</span>或使用教育圈标识等使第三方误认为是教育圈行为。<span lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>4)&nbsp;</span>通过使用任何自动化程序、软件、引擎、网络爬虫、网页分析工具、数据挖掘工具或类似工具，接入教育圈服务，收集或处理通过教育圈服务所提供的内容；<span\n" +
        "lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>5)&nbsp;</span>故意散播病毒、网络蠕虫、木马病毒或其他恶意代码；<span\n" +
        "lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>6)&nbsp;</span>攻击或者规避教育圈服务系统的任何安全功能；<span lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>7)&nbsp;</span>为破坏或滥用的目的开设多个帐户，或恶意上传重复的、无效的大容量数据和信息；<span\n" +
        "lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>8)&nbsp;</span>利用网络从事侵害他人名誉、隐私、知识产权和其他合法权益等活动；<span\n" +
        "lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>9)&nbsp;</span>违反任何相关的中国法律、法规、规章、条例等其他具有法律效力的规范；<span\n" +
        "lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>10</span>）对教育圈服务及相关功能进行修改、篡改、屏蔽或部分屏蔽内容；<span\n" +
        "lang=EN-US>&nbsp;<br>\n" +
        "</span>（<span lang=EN-US>11</span>）破坏教育圈的版权技术保护措施，未经许可盗用教育圈内容。<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.1pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>7.3&nbsp;</span><span\n' +
        'style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>除用户与我方另有约定外，用户同意教育圈的服务仅供用户个人非商业性质的使用，用户不可对教育圈服务的任何部分或服务之使用或获得进行复制、拷贝、出售，或利用教育圈进行调查、广告或其他商业目的，但我方对特定服务另有适用指引或规定的除外。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.1pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>7.4</span><span\n' +
        'style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>我方无法预先知晓并合理控制经由教育圈传送之内容，亦无法准确判定内容上传者的真实身份。有鉴于此，用户已预知使用教育圈时，可能会接触到令人不快、不适当或令人厌恶之内容，用户在此同意放弃由此而产生的针对我方的任何追索权。但我方有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用教育圈的全部或部分功能，保存有关记录，并向有关机关报告。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.1pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>7.5</span><span\n' +
        'style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>用户需独立对自己在教育圈上实施的行为承担法律责任。若用户使用教育圈服务的行为不符合本协议，我方有权做出独立判断，且在无需事先通知的情况下立即取消用户的帐号。用户若在教育圈上散布和传播反动、色情或其他违反国家法律的信息，教育圈的系统记录有可能作为用户违反法律的证据。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.1pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>7.6&nbsp;</span><span\n' +
        'style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>对于上传不良信息或者侵权信息等违反教育圈社区治理相关规则的用户，教育圈有权视情节严重程度对您采取警告、封号等惩罚措施。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.1pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>7.7</span><span\n' +
        'style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>在法律法规允许的范围内，用户同意并授权运营方就侵犯用户合法权益的行为（包括但不限于私自复制、使用、编辑、抄袭等行为）采取任何形式的法律行动，包括但不限于投诉、诉讼等必要的维权措施。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        "background:white'><span class=pt><b><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif"\'>8 </span></b></span><span class=pt><b><span\n' +
        'style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif"\'>免责声明</span></b></span><span\n' +
        'lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'><o:p></o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>8.1\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>用户在使用云圈服务的过程中应遵守国家法律法规及政策规定，对其所制作、上传、发送、传播的信息和内容承担任何法律责任，与云圈公司无关。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>8.2\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>云圈<span\n' +
        "lang=EN-US>APP</span>在其页面上向用户显示、推送的任何信息和内容如系云圈公司利用技术手段根据用户指令从互联网任何第三方网站搜索、定位、匹配后推荐给用户而非云圈公司单方制作的，则该显示、推送的信息和内容并不代表云圈公司及云圈<span\n" +
        "lang=EN-US>APP</span>的观点，云圈公司并不对上述信息的准确性和正确性负责。<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>8.3</span><span\n' +
        'style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>云圈公司提供云圈<span\n' +
        "lang=EN-US>APP</span>服务中所包含的任何文本、图片、标识、音频、视频资料均为教学用途，不涉及任何实体物品的商业活动。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>8.4</span><span\n' +
        'style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>云圈<span lang=EN-US>APP</span>在其页面上向用户显示、推送的任何信息和内容如存在侵权任何第三方知识产权的嫌疑，权利人和相关利害关系人应当向云圈公司发出权利通知，云圈公司经过核实后根据有关法律法规有权采取包括但不限于断开该侵权内容的链接或删除并停止传输该侵权内容，但云圈公司并不对该侵权内容承担法律责任。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>8.5</span><span\n' +
        'style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>用户违反本协议的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户同意赔偿云圈公司，使之免受损害。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        "background:white'><span class=pt><b><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif"\'>9. </span></b></span><span class=pt><b><span\n' +
        'style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif"\'>其他条款</span></b></span><span\n' +
        'lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'><o:p></o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>9.1\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>云圈公司有权随时修改本协议的任何条款，一旦本协议的内容发生变动，云圈公司将会在云圈<span\n' +
        "lang=EN-US>APP</span>平台中公布修改后的协议内容或通过其他适当方式向用户公布修改内容。用户不同意上述修改内容，有权选择停止使用云圈服务，但用户继续使用，则视为接受云圈公司对本协议相关条款的修改。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>9.2\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>本《协议》所定的任何条款无论因何种原因部分或全部无效或不具有执行力，本协议的其余条款仍应有效并具备约束力。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>9.3\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>本协议的订立、执行和解释及纠纷的解决均应适用中华人民共和国法律并受中华人民共和国法院管辖。如双方就本协议内容或执行发生任何纠纷或争议，首先应友好协商解决，协商不成的，任何一方均可向云圈公司所在地的有管辖权的人民法院提起诉讼。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>9.4\n' +
        '</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif"\'>本协议的版权归云圈公司所有，本协议各项条款内容的最终解释权及修改权归云圈公司所有。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p class=MsoNormal><span lang=EN-US><o:p>&nbsp;</o:p></span></p>\n" +
        "\n" +
        "</div>\n" +
        "\n" +
        "</body>\n" +
        "\n" +
        "</html>\n"
    };
  },
  methods: {},
  created () {
  },
  mounted () {
  }
};
</script>
<style scoped>
h1,
h2 {
  font-weight: bold;
  size: 26px;
}

ol {
  float: left;
  margin-left: 20px;
  padding: 10px;
}

li {
  flex: 1;
  margin-top: 10px;
}

ul {
  list-style-type: none;
  padding: 0;
}

a {
  color: #42b983;
}

p {
  color: #000;
  size: 26px;
  text-align: left;
  width: 100%;
  letter-spacing: 4px;
  line-height: 200%;
}

.hello {
  width: 100%;
}

img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/UserRule.vue